import { ELocalStorageKey } from '../enum/local-storage.enum'

export const cleanPackIdFromLocalStorage = () =>
  localStorage.removeItem(ELocalStorageKey.SELECTED_PACKAGE)

export const savePackIdInLocalStorage = (packId: string) =>
  localStorage.setItem(ELocalStorageKey.SELECTED_PACKAGE, packId)

export const readPackIdFromLocalStorage = () =>
  localStorage.getItem(ELocalStorageKey.SELECTED_PACKAGE)
